import { render, staticRenderFns } from "./wjx_iframe.vue?vue&type=template&id=dd2da6c4&scoped=true"
import script from "./wjx_iframe.vue?vue&type=script&lang=js"
export * from "./wjx_iframe.vue?vue&type=script&lang=js"
import style0 from "./wjx_iframe.vue?vue&type=style&index=0&id=dd2da6c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2da6c4",
  null
  
)

export default component.exports